// styles imports
import './Divider.scss';

// メインのコンポーネント定義
export default function Divider(props) {
  return (
    <div className={"divider " + (props.className ? props.className : "")}/>
  );
}
